export const stringToBoolean = stringValue => {
  if (stringValue === 'true') {
    return true;
  }
  return false;
};